import React from 'react'

import './styles.scss'

type HeadingTag = 'h1' | 'h2'

type Props = {
  title: string
  subtitle?: string
  /** Heading element. Defaults to `h1`. Use `h2` inside a page that already has an `h1`. */
  as?: HeadingTag
  id?: string
  className?: string
  /** Extra classes on the subtitle (e.g. `fs-5 fs-md-4`). Base subtitle styles always apply. */
  subtitleClassName?: string
}

const ContentPageHeader: React.FC<Props> = ({
  title,
  subtitle,
  as: Heading = 'h1',
  id,
  className,
  subtitleClassName,
}) => {
  const headerClassName = ['content-page-header', 'text-center', className]
    .filter(Boolean)
    .join(' ')

  const subtitleClassNameCombined = ['content-page-header__subtitle', 'fs-5', subtitleClassName]
    .filter(Boolean)
    .join(' ')

  return (
    <header className={headerClassName}>
      <Heading id={id} className='content-page-header__title fs-1 text-primary'>
        {title}
      </Heading>
      {subtitle ? (
        <p className={subtitleClassNameCombined}>{subtitle}</p>
      ) : null}
    </header>
  )
}

export default ContentPageHeader
